import { dateFormat } from '@cashew/utils';
import type React from 'react';
import './index.scss';

const ns = 'partners-list-item';

export type PartnerType = {
  id: number;
  name: string;
  phoneNumber: string;
  email: string;
  address: string;
  taxRegistrationNumber: string;
  country: string;
  cyclePeriod: number;
  brandName: string;
  logoImagePath: string;
  registrationDate: string;
};

interface PartnersTableItemsProps {
  data: PartnerType;
}

const PartnersTableItems: React.FC<PartnersTableItemsProps> = ({ data }) => {
  const { id, name, phoneNumber, email, registrationDate } = data;

  return (
    <div className={ns}>
      <div className={`${ns}__id`}>
        <p>{id}</p>
      </div>
      <div className={`${ns}__name`}>
        <p>{name}</p>
      </div>
      <div className={`${ns}__registration`}>
        <p>{dateFormat({ date: registrationDate })}</p>
      </div>
      <div className={`${ns}__phone`}>
        <p>{phoneNumber}</p>
      </div>
      <div className={`${ns}__email`}>
        <p>{email}</p>
      </div>
    </div>
  );
};

export default PartnersTableItems;
